import { commonFilter } from './filter';

export default {
  pageName: 'ByChannel-Download',
  pageId: '20107',
  pagePath: '/opinion/Accounts/ByChannel',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    ...commonFilter,
  },
};
